import { PaginationReturn } from '@common/types/service';
import { BLACKLIST_ADD_TABS, BlacklistDialogState, BlacklistEntry, BlacklistTableHeader } from '@event/types/event';
import { createContext, Dispatch, SetStateAction, useContext } from 'react';

const EventBlacklistContext = createContext<
    | {
          searchState: [string, Dispatch<SetStateAction<string>>];
          searchByState: [
              'name' | 'email' | 'company_name',
              Dispatch<SetStateAction<'name' | 'email' | 'company_name'>>
          ];
          pageState: [number, Dispatch<SetStateAction<number>>];
          rowsPerPageState: [number, Dispatch<SetStateAction<number>>];
          activeFiltersState: [Record<string, string[]>, Dispatch<SetStateAction<Record<string, string[]>>>];
          sortState: [
              { column: keyof BlacklistTableHeader; direction: 'asc' | 'desc' },
              Dispatch<SetStateAction<{ column: keyof BlacklistTableHeader; direction: 'asc' | 'desc' }>>
          ];
          dialogState: [BlacklistDialogState, Dispatch<SetStateAction<BlacklistDialogState>>];
          handleClose: () => void;
          handleAddToBlacklist: (emails: { email: string }[]) => void;
          handleGoBack: () => void;
          tabState: [BLACKLIST_ADD_TABS, Dispatch<SetStateAction<BLACKLIST_ADD_TABS>>];
          blacklistState: [PaginationReturn<BlacklistEntry, BlacklistEntry['email']> | undefined, boolean];
      }
    | undefined
>(undefined);

const useEventBlacklistContext = () => {
    const context = useContext(EventBlacklistContext);
    if (!context) throw new Error('useEventBlacklistContext must be used within a provider');
    return context;
};

export { EventBlacklistContext, useEventBlacklistContext };
